import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import React from 'react';
import { ImageCarousel } from '../../components';

const ImageCarouselContainer = props => {
  return (
    <ImageCarousel
      images={props.images}
      maxCarouselSize={props.maxCarouselSize}
      shared={props.shared}
      video={props.video}
      vfmFlagImages={props.vfmFlagImages}
    />
  );
};

ImageCarouselContainer.propTypes = {
  images: PropTypes.arrayOf(PropTypes.shape({
    thumbnailURL: PropTypes.string.isRequired,
    largeImageURL: PropTypes.string.isRequired,
    id: PropTypes.number.isRequired,
  })).isRequired,
  maxCarouselSize: PropTypes.number.isRequired,
  shared: PropTypes.shape({
    isShared: PropTypes.bool.isRequired,
    sharedMessage: PropTypes.string.isRequired,
  }).isRequired,
  video: PropTypes.shape({
    thumbnailURL: PropTypes.string,
    videoURL: PropTypes.string,
  }).isRequired,
  vfmFlagImages: PropTypes.arrayOf(PropTypes.shape({
    imageURL: PropTypes.string.isRequired,
    imageName: PropTypes.string.isRequired,
    hoverText: PropTypes.string.isRequired,
  })).isRequired,
};

const mapStateToProps = state => ({
  images: state.ImageCarousel.images,
  maxCarouselSize: state.ImageCarousel.maxCarouselSize,
  shared: state.ImageCarousel.shared,
  video: state.ImageCarousel.video,
  vfmFlagImages: state.ImageCarousel.vfmFlagImages,
});

export default connect(mapStateToProps)(ImageCarouselContainer);



// WEBPACK FOOTER //
// ./src/main/ui/react/product/src/containers/ImageCarousel/ImageCarousel.js